<div class="row">
    <div class="col-sm-12 col-md-6 col-lg-4 mt-3" *ngFor="let staff of data;let i=index">
        <div class="our-team">
            <div class="picture">
                <img class="img-fluid" [src]="staff.imgUrl" [alt]="staff.name">
            </div>
            <div class="team-content">
                <h3 class="name1">{{staff.name}}</h3>
                <h4 class="qual">{{staff.qualification}}</h4>
                <h4 class="qual">{{staff.exp}}</h4>
                <h4 class="qual">DOJ: {{staff.date}}</h4>
            </div>
            <h5>{{staff.designation}}</h5>
            <ul class="social">
                <li><a>{{staff.designation}}</a></li>
            </ul>
        </div>
    </div>
</div>